export default "__VITE_ASSET__07zBcVVS__"